// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `CSS Styles .table-container {
  width: 100%;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
}

.table-container td {
  padding: 20px 8px;
  border-bottom: 2px solid #f5f7fb;
  text-align: center;
}
.table-container-csv td {
  padding: 10px 4px;
  border-bottom: 2px solid #f5f7fb;
  text-align: center;
}

.table-container th {
  background-color: green;
  color: #fff;
}

/* Campaigns.css */

/* Add styles for pagination buttons */
.pagination {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 20px 0;
  justify-content: center;
}

.pagination__item {
  margin-right: 5px;
}

.pagination__link {
  padding: 8px 12px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  color: #333;
  text-decoration: none;
  cursor: pointer;
}

.pagination__link:hover {
  background-color: #e9e9e9;
}

.pagination__link--active {
  color: #fff;
}
.pagination__link--active a {
  background-color: rgb(126, 230, 126);
}

.pagination__link--disabled {
  pointer-events: none;
  opacity: 0.5;
}

/* Add padding to pageCount */
.pagination__page-count {
  margin: 7px;
  padding: 5px 12px;
  cursor: pointer;
  color: black;
  background: transparent;
}

.completed-status {
  background-color: rgb(99, 249, 99);
}

.live-status {
  background-color: rgb(13, 155, 250);
}

.pending-status {
  background-color: rgb(248, 248, 41);
}

/* Campaigns.css */

.table-wrapper {
  overflow-x: auto;
}

.table-container {
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 40px;
  margin-top: 30px;
}

/* Table styles */
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 15px;
  text-align: left;
}

/* Responsive styles */
@media (max-width: 768px) {
  .table-container {
    padding: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  table {
    font-size: 12px;
  }

  th,
  td {
    padding: 10px 5px;
  }

  button {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  table {
    font-size: 10px;
  }

  th,
  td {
    padding: 8px 4px;
  }

  button {
    font-size: 10px;
  }

  .table-container {
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/AdminDashboard/pages/Campaigns/Campaigns.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA,kBAAkB;;AAElB,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF","sourcesContent":["CSS Styles .table-container {\r\n  width: 100%;\r\n}\r\n\r\n.table-container table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.table-container td {\r\n  padding: 20px 8px;\r\n  border-bottom: 2px solid #f5f7fb;\r\n  text-align: center;\r\n}\r\n.table-container-csv td {\r\n  padding: 10px 4px;\r\n  border-bottom: 2px solid #f5f7fb;\r\n  text-align: center;\r\n}\r\n\r\n.table-container th {\r\n  background-color: green;\r\n  color: #fff;\r\n}\r\n\r\n/* Campaigns.css */\r\n\r\n/* Add styles for pagination buttons */\r\n.pagination {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 20px 0;\r\n  justify-content: center;\r\n}\r\n\r\n.pagination__item {\r\n  margin-right: 5px;\r\n}\r\n\r\n.pagination__link {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  background-color: #f9f9f9;\r\n  color: #333;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination__link:hover {\r\n  background-color: #e9e9e9;\r\n}\r\n\r\n.pagination__link--active {\r\n  color: #fff;\r\n}\r\n.pagination__link--active a {\r\n  background-color: rgb(126, 230, 126);\r\n}\r\n\r\n.pagination__link--disabled {\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Add padding to pageCount */\r\n.pagination__page-count {\r\n  margin: 7px;\r\n  padding: 5px 12px;\r\n  cursor: pointer;\r\n  color: black;\r\n  background: transparent;\r\n}\r\n\r\n.completed-status {\r\n  background-color: rgb(99, 249, 99);\r\n}\r\n\r\n.live-status {\r\n  background-color: rgb(13, 155, 250);\r\n}\r\n\r\n.pending-status {\r\n  background-color: rgb(248, 248, 41);\r\n}\r\n\r\n/* Campaigns.css */\r\n\r\n.table-wrapper {\r\n  overflow-x: auto;\r\n}\r\n\r\n.table-container {\r\n  padding: 20px;\r\n  border-radius: 20px;\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\r\n  margin-bottom: 40px;\r\n  margin-top: 30px;\r\n}\r\n\r\n/* Table styles */\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nth,\r\ntd {\r\n  padding: 15px;\r\n  text-align: left;\r\n}\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n  .table-container {\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  th,\r\n  td {\r\n    padding: 10px 5px;\r\n  }\r\n\r\n  button {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  table {\r\n    font-size: 10px;\r\n  }\r\n\r\n  th,\r\n  td {\r\n    padding: 8px 4px;\r\n  }\r\n\r\n  button {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .table-container {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
